/* eslint-disable */

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(LanguageDetector).init({
  // we init with resources
  nsSeparator: false,
  keySeparator: false,
  resources: {
    en: {
      translations: {
        From: 'From',
        to: 'to',
        'To know more about it': 'To know more about it',
        'What is the blockchain': 'What is the blockchain',
        'How is the blockchain used to certify documents or data?':
          'How is the blockchain used to certify documents or data?',
        'No data yet': 'No data yet',
        'To get started, edit <1>src/App.js</1> and save to reload.':
          'To get started, edit <1>src/App.js</1> and save to reload.',
        'Welcome to Attributes': 'Welcome to Attributes',
        'We connect the green energy worlds through Blockchain.':
          'We connect the green energy worlds through Blockchain.',
        Username: 'Username',
        Password: 'Password',
        'Sign In': 'Sign In',
        Users: 'Users',
        Organizations: 'Organizations',
        Countries: 'Countries',
        'Unknown organization': 'Unknown organization',
        'Organization name': 'Organization name',
        'Organization information': 'Organization information',
        'Update organization': 'Update organization',
        'Create organization': 'Create organization',
        'There is no organization yet': 'There is no organization yet',
        'Check certificate': 'Check certificate',
        'Check certificate’s authenticity': 'Check certificate’s authenticity',
        'Producing assets': 'Producing assets',
        'Made with': 'Made with',
        by: 'by',
        'and certified on the Energy Web Foundation Blockchain':
          'and certified on the Energy Web Foundation Blockchain',
        Site: 'Site',
        'Consumption assets': 'Consumption assets',
        'Production assets': 'Production assets',
        For: 'For',
        Between: 'Between',
        Export: 'Export',
        Unit: 'Unit',
        'Select report unit': 'Select report unit',
        'All (fem)': 'All',
        All: 'All',
        'Select organization': 'Select organization',
        'Please wait': 'Please wait',
        'Production report': 'Production report',
        'Export monthly energy production data':
          'Export monthly energy production data',
        'Allocated to': 'Allocated to',
        'Certified by': 'Certified by',
        'On the date of': 'On the date of',
        'On the date (in UTC)': 'On the date (in UTC)',
        'For month of': 'For month of',
        'Consumption asset': 'Consumption asset',
        'Production asset': 'Production asset',
        Certificates: 'Certificates',
        Certificate: 'Certificate',
        Secret: 'Secret',
        'Blockchain proof': 'Blockchain proof',
        Fingerprint: 'Fingerprint',
        'Loading secret word...': 'Loading secret word...',
        'Secret word': 'Secret word',
        'This is the secret used to anonymize your data in the Blockchain.':
          'This is the secret used to anonymize your data in the Blockchain.',
        Retire: 'Retire',
        Dashboard: 'Dashboard',
        'High Fidelity Green Energy Certificates':
          'High Fidelity Green Energy Certificates',
        Consumption: 'Consumption',
        'Monthly generated certificates': 'Monthly generated certificates',
        'The quantity of green energy allocated each month, in MWh':
          'The quantity of green energy allocated each month, in MWh',
        'Customer deliveries': 'Customer deliveries',
        Deliveries: 'Deliveries',
        Method: 'Method',
        Logout: 'Logout',
        Asset: 'Asset',
        Country: 'Country',
        'Global view': 'Global view',
        'Country view': 'Country view',
        Owner: 'Owner',
        'Avoided CO2': 'Avoided CO2',
        'of CO2 avoided': 'of CO2 avoided',
        'This is equivalent to': 'This is equivalent to',
        'Yearly CO2 equivalent': 'Yearly CO2 equivalent',
        'driven by an average passenger vehicle':
          'driven by an average passenger vehicle',
        'World tour conversion': 'World tour conversion',
        'world tours by plane for one passenger':
          'world tours by plane for one passenger',
        'urban tree seedlings grown for 10 years':
          'urban tree seedlings grown for 10 years',
        'Number of urban tree seedlings grown for 10 years, having one urban tree planted for:':
          'Number of urban tree seedlings grown for 10 years, having one urban tree planted for',
        'metric ton CO2 avoided.': 'metric ton CO2 avoided.',
        'Urban Tree Planted': 'Urban Tree Planted',
        'Nuclear waste': 'Nuclear waste',
        'of nuclear waste': 'of nuclear waste',
        'The production of 1 MWh of nuclear electricity produces about ':
          'The production of 1 MWh of nuclear electricity produces about',
        'g of radioactive waste.': 'g of radioactive waste.',
        'of radioactive waste.': 'of radioactive waste.',
        'Homes conversion': 'Homes conversion',
        homes: 'homes',
        'Green electricity': 'Green electricity',
        millions: 'millions',
        billions: 'billions',
        'Monthly Calculation': 'Monthly Calculation',
        'Yearly Calculation': 'Yearly Calculation',
        'Calculation method for avoided CO2 emissions':
          'Calculation method for avoided CO2 emissions',
        'Monthly refers to the last month matched':
          'Monthly refers to the last month matched',
        'Yearly refers to the year-to-date for the last matching date':
          'Yearly refers to the year-to-date for the last matching date',
        'For each day, we retrieve the average CO2 emissions for that day (g of CO2 /kWh).':
          'For each day, we retrieve the average CO2 emissions for that day (g of CO2 /kWh).',
        'lbs of CO2/MWh': 'lbs of CO2/MWh',
        'g of CO2/kWh': 'g of CO2/kWh',
        'For each day, we retrieve the average CO2 emissions for that day':
          'For each day, we retrieve the average CO2 emissions for that day',
        '(for France).': '(for France).',
        '(for US).': '(for US).',
        'With the avoided CO2, the driven distance is calculated using':
          'With the avoided CO2, the driven distance is calculated using',
        'gCO2/km which is the average given the geographical location of the current organization.':
          'gCO2/km which is the average given the geographical location of the current organization.',
        'which is the average given the geographical location of the current organization.':
          'which is the average given the geographical location of the current organization.',
        'With the avoided CO2, the plane distance is calculated using':
          'With the avoided CO2, the plane distance is calculated using',
        'gCO2/km and a distance of': 'gCO2/km and a distance of',
        'and a distance of': 'and a distance of',
        'km for a world tour.': 'km for a world tour.',
        'for a world tour.': 'for a world tour.',
        'Equivalence in electricity consumption of X homes. To find out the average electricity consumption of a residential home, just divide the total amount of residential electricity consumed (in TWh) by the number of residential homes =':
          'Equivalence in electricity consumption of X homes. To find out the average electricity consumption of a residential home, just divide the total amount of residential electricity consumed (in TWh) by the number of residential homes =',
        'kWh annual electricity consumption per household.':
          'kWh annual electricity consumption per household.',
        'Avoided CO2 : Traditional GOs': 'Avoided CO2 : Traditional GOs',
        'Scope 3 : Transport CO2 emissions':
          'Scope 3 : Transport CO2 emissions',
        "Avoided CO2 : Certified On Attributes's blockchain":
          "Avoided CO2 : Certified On Attributes's blockchain",
        'Avoided CO2 : Certified by Attributes':
          'Avoided CO2 : Certified by Attributes',
        'Tracked avoided CO2 emissions': 'Tracked avoided CO2 emissions',
        'Avoided CO2 in kg': 'Tracked avoided CO2 in kg',
        'Avoided CO2 in lb': 'Tracked avoided CO2 in lb',
        'Power in kWh': 'Power in kWh',
        Date: 'Date',
        'Delivery Id': 'Delivery Id',
        Product: 'Product',
        'Avoided CO2 (kg)': 'Tracked avoided CO2 (kg)',
        'CO2 Emissions (kg)': 'CO2 Emissions (kg)',
        'Site Id': 'Site Id',
        Reference: 'Reference',
        Customer: 'Customer',
        'Customer Id': 'Customer Id',
        'Download PDF': 'Download PDF',
        'Generating your PDF...': 'Generating your PDF...',
        'Loading the data, please wait': 'Loading the data, please wait',
        'Total Green Energy': 'Total Green Energy',
        on: 'on',
        'out of': 'out of',
        consumed: 'consumed',
        'From wind turbines': 'From wind turbines',
        'From hydroelectric power': 'From hydroelectric power',
        'From solar panels': 'From solar panels',
        'From geothermal': 'From geothermal',
        'From solid biomass': 'From solid biomass',
        'Consuming assets': 'Consuming assets',
        'Energy produced by ': 'Electricity produced by ',
        'Asset production': 'Asset production',
        'Energy from ': 'Electricity from ',
        Wind: 'Wind',
        Solar: 'Solar',
        RunRiverHydro: 'RunRiverHydro',
        Geothermal: 'Geothermal',
        SolidBiomass: 'SolidBiomass',
        BiomassGas: 'BiomassGas',
        'matched energy': 'matched energy',
        'residual energy': 'residual energy',
        'Asset matched production': 'Asset matched production',
        ' (in ': ' (in ',
        Capacity: 'Capacity',
        'Owner  blockchain address': 'Owner  blockchain address',
        Weather: 'Weather',
        Forecast: 'Forecast',
        'Check your certificate': 'Check your certificate',
        'Check your report': 'Check your report',
        "Upload your certificate and check it's authenticity.":
          "Upload your certificate and check it's authenticity.",
        'Upload your report and check its authenticity.':
          'Upload your report and check its authenticity.',
        'Drag and drop your certificate here':
          'Drag and drop your certificate here',
        'Drag and drop your report here': 'Drag and drop your report here',
        'Checking your certificate...': 'Checking your certificate...',
        'Checking your report...': 'Checking your report...',
        'Sorry, we can’t find this certificate':
          'Sorry, we can’t find this certificate',
        'Sorry, we can’t find this report': 'Sorry, we can’t find this report',
        'This certificate is authentic': 'This certificate is authentic',
        'This report is authentic': 'This report is authentic',
        Power: 'Power',
        'Production date ': 'Production date ',
        'No certificate uploaded': 'No certificate uploaded',
        'No report uploaded': 'No report uploaded',
        'No figures': 'No figures',
        Stacked: 'Stacked',
        'Not stacked': 'Not stacked',
        Download: 'Download',
        'Consumption & related Production': 'Consumption & related Production',
        'The consumption of the asset compared to the renewable energy producing assets':
          'The consumption of the asset compared to the renewable energy producing assets',
        'Key figures': 'Key figures',
        'Last 30 days': 'Last 30 days',
        'last 30 days': 'last 30 days',
        'Last month': 'last month',
        Monthly: 'Monthly',
        'last day': 'last day',
        'last 12 months': 'last 12 months',
        'Last 12 months': 'Last 12 months',
        Yearly: 'Yearly',
        'Energy sources ratio': 'Electricity sources ratio',
        'Matching ratio': 'Matching ratio',
        ratio: 'ratio',
        'The matching rate for each date and hour':
          'The matching rate for each date and hour',
        'Average matching ratio': 'Average matching ratio',
        'The average matching rate per hour':
          'The average matching rate per hour',
        "The sources of your asset's energy consumption":
          "The sources of your asset's electricity consumption",
        'Yesterday’s energy sources': 'Yesterday’s electricity sources',
        'Energy Sources for the': 'Electricity Sources for the',
        "The sources of your asset's energy consumption (yesterday)":
          "The sources of your asset's electricity consumption (yesterday)",
        "The sources of your asset's energy consumption for this date":
          "The sources of your asset's electricity consumption for this date",
        'Average matching distance': 'Average matching distance',
        'Average distance': 'Average distance',
        ' ton': ' tons',
        tons: ' tons',
        ton: ' ton',
        RowsPerPage: 'Rows per page:',
        ' of ': ' of ',
        'Filter list': 'Filter list',
        'Export data': 'Export data',
        'Delevery Id': 'Delevery Id',
        'Site id or name': 'Site id or name',
        'Customer id or name': 'Customer id or name',
        'Filter by product': 'Filter by product',
        Start: 'Start',
        End: 'End',
        'Matching date': 'Matching date',
        'Start date': 'Start date',
        'End date': 'End date',
        'check transaction': 'check transaction',
        'Download certificate': 'Download certificate',
        Sort: 'Sort',
        'Wind (Fontanelles)': 'Wind (Fontanelles)',
        'Energy Mix': 'Energy Mix',
        'Lida consumption': 'Lida consumption',
        'Marèges produced energy': 'Marèges produced energy',
        'Fontanelles produced energy': 'Fontanelles produced energy',
        'Eget produced energy': 'Eget produced energy',
        'Soulom produced energy': 'Soulom produced energy',
        YYYY: 'YYYY',
        MM: 'MM',
        'DD ': 'DD ',
        HH: 'HH',
        mm: 'mm',
        'Green Energy Certificate': 'Green Energy Certificate',
        'For the amount of': 'For the amount of',
        ' Kilo Watt-Hour (': ' Kilo Watt-Hour (',
        ' kg of CO2 saved )': ' kg of CO2 saved )',
        'Produced by the renewable ': 'Produced by the renewable ',
        'Produced by the renewable asset': 'Produced by the renewable asset',
        ' resource': ' resource',
        ' Blockchain address ': ' Blockchain address ',
        'On the date': 'On the date',
        'Used for the exclusive and sole account of':
          'Used for the exclusive and sole account of',
        'Transferred on ': 'Transferred on ',
        'Transferred ': 'Transferred ',
        ' to account': ' to account',
        'This information is publicly and unalterably available in the Blockchain : ':
          'This information is publicly and unalterably available in the Blockchain : ',
        'and can be visible here ': 'and can be visible here ',
        unauthorized:
          "You doesn't have access right to this page, please contact an administrator",
      },
    },
    en_us: {
      translations: {
        From: 'From',
        to: 'to',
        'To know more about it': 'To know more about it',
        'What is the blockchain': 'What is the blockchain',
        'How is the blockchain used to certify documents or data?':
          'How is the blockchain used to certify documents or data?',
        'No data yet': 'No data yet',
        'To get started, edit <1>src/App.js</1> and save to reload.':
          'To get started, edit <1>src/App.js</1> and save to reload.',
        'Welcome to Attributes': 'Welcome to Attributes',
        'We connect the green energy worlds through Blockchain.':
          'We connect the green energy worlds through Blockchain.',
        Username: 'Username',
        Password: 'Password',
        'Sign In': 'Sign In',
        Users: 'Users',
        Organizations: 'Organizations',
        Countries: 'Countries',
        'Unknown organization': 'Unknown organization',
        'Organization name': 'Organization name',
        'Organization information': 'Organization information',
        'Update organization': 'Update organization',
        'Create organization': 'Create organization',
        'There is no organization yet': 'There is no organization yet',
        'Check certificate': 'Check certificate',
        'Check certificate’s authenticity': 'Check certificate’s authenticity',
        'Producing assets': 'Producing assets',
        'Made with': 'Made with',
        by: 'by',
        'and certified on the Energy Web Foundation Blockchain':
          'and certified on the Energy Web Foundation Blockchain',
        Site: 'Site',
        'Consumption assets': 'Consumption assets',
        'Production assets': 'Production assets',
        For: 'For',
        Between: 'Between',
        Export: 'Export',
        Unit: 'Unit',
        'Select report unit': 'Select report unit',
        'All (fem)': 'All',
        All: 'All',
        'Select organization': 'Select organization',
        'Please wait': 'Please wait',
        'Production report': 'Production report',
        'Export monthly energy production data':
          'Export monthly energy production data',
        'Allocated to': 'Allocated to',
        'Certified by': 'Certified by',
        'On the date of': 'On the date of',
        'On the date (in UTC)': 'On the date (in UTC)',
        'For month of': 'For month of',
        'Consumption asset': 'Consumption asset',
        'Production asset': 'Production asset',
        Certificates: 'Certificates',
        Certificate: 'Certificate',
        Secret: 'Secret',
        'Blockchain proof': 'Blockchain proof',
        Fingerprint: 'Fingerprint',
        'Loading secret word...': 'Loading secret word...',
        'Secret word': 'Secret word',
        'This is the secret used to anonymize your data in the Blockchain.':
          'This is the secret used to anonymize your data in the Blockchain.',
        Retire: 'Retire',
        Dashboard: 'Dashboard',
        'High Fidelity Green Energy Certificates':
          'High Fidelity Green Energy Certificates',
        Consumption: 'Consumption',
        'Monthly generated certificates': 'Monthly generated certificates',
        'The quantity of green energy allocated each month, in MWh':
          'The quantity of green energy allocated each month, in MWh',
        'Customer deliveries': 'Customer deliveries',
        Deliveries: 'Deliveries',
        Method: 'Method',
        Logout: 'Logout',
        Asset: 'Asset',
        Country: 'Country',
        'Global view': 'Global view',
        'Country view': 'Country view',
        Owner: 'Owner',
        'Avoided CO2': 'Avoided CO2',
        'of CO2 avoided': 'of CO2 avoided',
        'This is equivalent to': 'This is equivalent to',
        'Yearly CO2 equivalent': 'Yearly CO2 equivalent',
        'driven by an average passenger vehicle':
          'driven by an average passenger vehicle',
        'World tour conversion': 'World tour conversion',
        'world tours by plane for one passenger':
          'world tours by plane for one passenger',
        'urban tree seedlings grown for 10 years':
          'urban tree seedlings grown for 10 years',
        'Number of urban tree seedlings grown for 10 years, having one urban tree planted for':
          'Number of urban tree seedlings grown for 10 years, having one urban tree planted for',
        'metric ton CO2 avoided.': 'metric ton CO2 avoided.',
        'Urban Tree Planted': 'Urban Tree Planted',
        'Nuclear waste': 'Nuclear waste',
        'of nuclear waste': 'of nuclear waste',
        'The production of 1 MWh of nuclear electricity produces about ':
          'The production of 1 MWh of nuclear electricity produces about',
        'g of radioactive waste.': 'g of radioactive waste.',
        'of radioactive waste.': 'of radioactive waste.',
        'Homes conversion': 'Homes conversion',
        homes: 'homes',
        'Green electricity': 'Green electricity',
        millions: 'millions',
        billions: 'billions',
        'Monthly Calculation': 'Monthly Calculation',
        'Yearly Calculation': 'Yearly Calculation',
        'Calculation method for avoided CO2 emissions':
          'Calculation method for avoided CO2 emissions',
        'Monthly refers to the last month matched':
          'Monthly refers to the last month matched',
        'Yearly refers to the year-to-date for the last matching date':
          'Yearly refers to the year-to-date for the last matching date',
        'For each day, we retrieve the average CO2 emissions for that day (g of CO2 /kWh).':
          'For each day, we retrieve the average CO2 emissions for that day (g of CO2 /kWh).',
        'lbs of CO2/MWh': 'lbs of CO2/MWh',
        'g of CO2/kWh': 'g of CO2/kWh',
        'For each day, we retrieve the average CO2 emissions for that day':
          'For each day, we retrieve the average CO2 emissions for that day',
        '(for France).': '(for France).',
        '(for US).': '(for US).',
        'With the avoided CO2, the driven distance is calculated using':
          'With the avoided CO2, the driven distance is calculated using',
        'gCO2/km which is the average given the geographical location of the current organization.':
          'gCO2/km which is the average given the geographical location of the current organization.',
        'which is the average given the geographical location of the current organization.':
          'which is the average given the geographical location of the current organization.',
        'With the avoided CO2, the plane distance is calculated using':
          'With the avoided CO2, the plane distance is calculated using',
        'gCO2/km and a distance of': 'gCO2/km and a distance of',
        'and a distance of': 'and a distance of',
        'km for a world tour.': 'km for a world tour.',
        'or a world tour.': 'for a world tour.',
        'Equivalence in electricity consumption of X homes. To find out the average electricity consumption of a residential home, just divide the total amount of residential electricity consumed (in TWh) by the number of residential homes =':
          'Equivalence in electricity consumption of X homes. To find out the average electricity consumption of a residential home, just divide the total amount of residential electricity consumed (in TWh) by the number of residential homes =',
        'kWh annual electricity consumption per household.':
          'kWh annual electricity consumption per household.',
        'Avoided CO2 : Traditional GOs': 'Avoided CO2 : Traditional GOs',
        'Scope 3 : Transport CO2 emissions':
          'Scope 3 : Transport CO2 emissions',
        "Avoided CO2 : Certified On Attributes's blockchain":
          "Avoided CO2 : Certified On Attributes's blockchain",
        'Avoided CO2 : Certified by Attributes':
          'Avoided CO2 : Certified by Attributes',
        'Tracked avoided CO2 emissions': 'Tracked avoided CO2 emissions',
        'Avoided CO2 in kg': 'Tracked avoided CO2 in kg',
        'Avoided CO2 in lb': 'Tracked avoided CO2 in lb',
        'Power in kWh': 'Power in kWh',
        Date: 'Date',
        'Delivery Id': 'Delivery Id',
        Product: 'Product',
        'Avoided CO2 (kg)': 'Tracked avoided CO2 (kg)',
        'CO2 Emissions (kg)': 'CO2 Emissions (kg)',
        'Site Id': 'Site Id',
        Reference: 'Reference',
        Customer: 'Customer',
        'Customer Id': 'Customer Id',
        'Download PDF': 'Download PDF',
        'Generating your PDF...': 'Generating your PDF...',
        'Loading the data, please wait': 'Loading the data, please wait',
        'Total Green Energy': 'Total Green Energy',
        on: 'on',
        'out of': 'out of',
        consumed: 'consumed',
        'From wind turbines': 'From wind turbines',
        'From hydroelectric power': 'From hydroelectric power',
        'From solar panels': 'From solar panels',
        'From geothermal': 'From geothermal',
        'From solid biomass': 'From solid biomass',
        'Consuming assets': 'Consuming assets',
        'Energy produced by ': 'Electricity produced by ',
        'Asset production': 'Asset production',
        'Energy from ': 'Electricity from ',
        Wind: 'Wind',
        Solar: 'Solar',
        RunRiverHydro: 'RunRiverHydro',
        Geothermal: 'Geothermal',
        SolidBiomass: 'SolidBiomass',
        BiomassGas: 'BiomassGas',
        'matched energy': 'matched energy',
        'residual energy': 'residual energy',
        'Asset matched production': 'Asset matched production',
        ' (in ': ' (in ',
        Capacity: 'Capacity',
        'Owner  blockchain address': 'Owner  blockchain address',
        Weather: 'Weather',
        Forecast: 'Forecast',
        'Check your certificate': 'Check your certificate',
        'Check your report': 'Check your report',
        "Upload your certificate and check it's authenticity.":
          "Upload your certificate and check it's authenticity.",
        'Upload your report and check its authenticity.':
          'Upload your report and check its authenticity.',
        'Drag and drop your certificate here':
          'Drag and drop your certificate here',
        'Drag and drop your report here': 'Drag and drop your report here',
        'Checking your certificate...': 'Checking your certificate...',
        'Checking your report...': 'Checking your report...',
        'Sorry, we can’t find this certificate':
          'Sorry, we can’t find this certificate',
        'Sorry, we can’t find this report': 'Sorry, we can’t find this report',
        'This certificate is authentic': 'This certificate is authentic',
        'This report is authentic': 'This report is authentic',
        Power: 'Power',
        'Production date ': 'Production date ',
        'No certificate uploaded': 'No certificate uploaded',
        'No report uploaded': 'No report uploaded',
        'No figures': 'No figures',
        Stacked: 'Stacked',
        'Not stacked': 'Not stacked',
        Download: 'Download',
        'Consumption & related Production': 'Consumption & related Production',
        'The consumption of the asset compared to the renewable energy producing assets':
          'The consumption of the asset compared to the renewable energy producing assets',
        'Key figures': 'Key figures',
        'Last 30 days': 'Last 30 days',
        'last 30 days': 'last 30 days',
        'Last month': 'last month',
        Monthly: 'Monthly',
        'last day': 'last day',
        'last 12 months': 'last 12 months',
        'Last 12 months': 'Last 12 months',
        Yearly: 'Yearly',
        'Energy sources ratio': 'Electricity sources ratio',

        "The sources of your asset's energy consumption":
          "The sources of your asset's electricity consumption",
        'Yesterday’s energy sources': 'Yesterday’s electricity sources',
        'Energy Sources for the': 'Electricity Sources for the',
        "The sources of your asset's energy consumption (yesterday)":
          "The sources of your asset's electricity consumption (yesterday)",
        "The sources of your asset's energy consumption for this date":
          "The sources of your asset's electricity consumption for this date",
        'Average matching distance': 'Average matching distance',
        'Average distance': 'Average distance',
        ' ton': ' tons',
        tons: ' tons',
        ton: ' ton',
        RowsPerPage: 'Rows per page:',
        ' of ': ' of ',
        'Filter list': 'Filter list',
        'Export data': 'Export data',
        'Delevery Id': 'Delevery Id',
        'Site id or name': 'Site id or name',
        'Customer id or name': 'Customer id or name',
        'Filter by product': 'Filter by product',
        Start: 'Start',
        End: 'End',
        'Matching date': 'Matching date',
        'Start date': 'Start date',
        'End date': 'End date',
        'check transaction': 'check transaction',
        'Download certificate': 'Download certificate',
        Sort: 'Sort',
        'Wind (Fontanelles)': 'Wind (Fontanelles)',
        'Energy Mix': 'Energy Mix',
        'Lida consumption': 'Lida consumption',
        'Marèges produced energy': 'Marèges produced energy',
        'Fontanelles produced energy': 'Fontanelles produced energy',
        'Eget produced energy': 'Eget produced energy',
        'Soulom produced energy': 'Soulom produced energy',
        YYYY: 'YYYY',
        MM: 'MM',
        'DD ': 'DD ',
        HH: 'HH',
        mm: 'mm',
        'Green Energy Certificate': 'Green Energy Certificate',
        'For the amount of': 'For the amount of',
        ' Kilo Watt-Hour (': ' Kilo Watt-Hour (',
        ' kg of CO2 saved )': ' kg of CO2 saved )',
        'Produced by the renewable ': 'Produced by the renewable ',
        'Produced by the renewable asset': 'Produced by the renewable asset',
        ' resource': ' resource',
        ' Blockchain address ': ' Blockchain address ',
        'On the date': 'On the date',
        'Used for the exclusive and sole account of':
          'Used for the exclusive and sole account of',
        'Transferred on ': 'Transferred on ',
        'Transferred ': 'Transferred ',
        ' to account': ' to account',
        'This information is publicly and unalterably available in the Blockchain : ':
          'This information is publicly and unalterably available in the Blockchain : ',
        'and can be visible here ': 'and can be visible here ',
        unauthorized:
          "You doesn't have access right to this page, please contact an administrator",
      },
    },
    fr: {
      translations: {
        From: 'Du',
        to: 'au',
        'To know more about it': 'En savoir plus',
        'What is the blockchain': 'Qu’est ce que la blockchain',
        'How is the blockchain used to certify documents or data?':
          'Comment la blockchain est-elle utilisée pour certifier des documents ou des données?',
        'To get started, edit <1>src/App.js</1> and save to reload.':
          'Starte in dem du, <1>src/App.js</1> editierst und speicherst.',
        'No data yet': 'Données non disponible',
        'Welcome to Attributes': 'Bienvenue sur Attributes',
        'We connect the green energy worlds through Blockchain.':
          'Nous connectons le monde des énergies renouvelables par la Blockchain',
        Username: 'Nom Utilisateur',
        Password: 'Mot de passe',
        'Sign In': 'Se Connecter',
        Users: 'Utilisateurs',
        Organizations: 'Organisations',
        Organization: 'Organisation',
        'Unknown organization': 'Organisation inconnue',
        'Organization name': "Nom de l'organisation",
        'Organization information': "Informations sur l'organisation",
        'Update organization': 'Mettre à jour',
        'Create organization': 'Créer',
        'There is no organization yet': "Il n'y a pas encore d'organisation",
        'Check certificate': 'Vérification de certificat',
        'Check certificate’s authenticity':
          "Vérifier l' authenticité du certificat",
        'Producing assets': 'Sites de Production',
        'Made with': 'Fait avec',
        by: 'par',
        'and certified on the Energy Web Foundation Blockchain':
          "et certifié sur la blockchain de l'Energy Web Foundation",
        Site: 'Site',
        'Consumption assets': 'Sites de consommation',
        'Production assets': 'Sites de production',
        'All (fem)': 'Toutes',
        All: 'Tous',
        'Select organization': 'Sélectionner une organisation',
        'Select report unit': "Sélectionner l'unité",
        Export: 'Exporter',
        Unit: 'Unité',
        Between: 'Entre',
        For: 'Pour',
        'Please wait': 'Veuillez patienter',
        'Production report': 'Rapport de production',
        'Export monthly energy production data':
          "Exporter les données de production d'énergie mensuelles par asset",
        'Consumption asset': 'Site de consommation',
        'Allocated to': 'Alloué à',
        'Production asset': 'Site de production',
        Certificates: 'Certificats',
        Certificate: 'Certificat',
        Secret: 'Secret',
        'Blockchain proof': 'Preuve blockchain',
        Fingerprint: 'Empreinte digitale',
        'Certified by': 'Certifié par',
        'On the date of': 'En date du',
        'Loading secret word...': 'Chargement du mot secret...',
        'Secret word': 'Mot secret',
        'This is the secret used to anonymize your data in the Blockchain.':
          'Le secret utilisé pour anonymiser vos données dans la Blockchain.',
        Retire: 'Retirer',
        Dashboard: 'Tableau de bord',
        'High Fidelity Green Energy Certificates':
          "Certificats d'énergie verte haute fidélité",
        Consumption: 'Consommation',
        'Monthly generated certificates': 'Certificats agrégés mensuellement',
        'The quantity of green energy allocated each month, in MWh':
          "La quantité d'énergie verte allouée, par mois, en MWh",
        'Customer deliveries': 'Livraisons',
        Deliveries: 'Livraisons',
        Method: 'Méthode',
        Logout: 'Déconnexion',
        Asset: 'Site',
        Country: 'Pays',
        'Global view': 'Vue globale',
        'Country view': 'Vue par pays',
        Owner: 'Propriétaire',
        'Avoided CO2': 'CO2 évité',
        'of CO2 avoided': 'de CO2 évité',
        'This is equivalent to': 'Ceci équivaut à',
        'Yearly CO2 equivalent': 'Equivalent CO2 annuel',
        'driven by an average passenger vehicle': 'parcourus en voiture',
        'World tour conversion': 'Conversion en tour du monde',
        'world tours by plane for one passenger':
          'tours du monde en avion pour un passager',
        'Urban Tree Planted': "Nombres d'arbres plantés",
        'Number of urban tree seedlings grown for 10 years, having one urban tree planted for':
          "Nombre de semis d'arbres urbains cultivés pendant 10 ans en ayant un arbre urbain planté pour",
        'metric ton CO2 avoided.': 'tonne de CO2 évitée.',
        'urban tree seedlings grown for 10 years':
          "semis d'arbres urbains cultivés pendant 10 ans",
        'Nuclear waste': 'Déchets nucléaires',
        'of nuclear waste': 'de déchets nucléaires',
        'The production of 1 MWh of nuclear electricity produces about':
          'La production de 1 MWh d’électricité d’origine nucléaire produit environ',
        'g of radioactive waste.': 'g de déchets radioactifs.',
        'of radioactive waste.': 'de déchets radioactifs.',
        'Homes conversion': 'Conversion en nombre de foyers',
        homes: 'foyers',
        'Green electricity': 'Electricité verte',
        millions: 'millions',
        billions: 'milliards',
        'Calculation method for avoided CO2 emissions':
          'Méthode de calcul des émissions de CO2 évitées',
        'Monthly Calculation': 'Calcul mensuel',
        'Yearly Calculation': 'Calcul annuel',
        'Monthly refers to the last month matched':
          'Concerne le mois du dernier matching',
        'Yearly refers to the year-to-date for the last matching date':
          "Correspond au calcul cumulé sur l'année du dernier mois matché ",
        'For each day, we retrieve the average CO2 emissions for that day (g of CO2 /kWh).':
          'Pour chaque journée, nous récupérons la moyenne des émissions de CO2 pour ce jour (en g de CO2 /kWh).',
        'lbs of CO2/MWh': 'lbs de CO2/MWh',
        'g of CO2/kWh': 'g de CO2/kWh',
        'For each day, we retrieve the average CO2 emissions for that day':
          'Pour chaque journée, nous récupérons la moyenne des émissions de CO2 pour ce jour',
        '(for France).': '(pour la France).',
        '(for US).': '(pour les États Unis).',
        'With the avoided CO2, the driven distance is calculated using':
          'Avec la donnée de CO2 évité, la distance parcourue est calculée en utilisant',
        'gCO2/km which is the average given the geographical location of the current organization.':
          "gCO2/km qui est la moyenne des émissions compte tenu de la position géographique de l'organisation actuelle.",
        'which is the average given the geographical location of the current organization.':
          "qui est la moyenne des émissions compte tenu de la position géographique de l'organisation actuelle.",
        'With the avoided CO2, the plane distance is calculated using':
          'Avec la donnée de CO2 évité, la distance parcourue en avions est calculée en utilisant',
        'gCO2/km and a distance of': 'gCO2/km et une distance de',
        'and a distance of': 'et une distance de',
        'km for a world tour.': 'km pour un tour du monde.',
        'for a world tour.f': 'pour un tour du monde.',
        'Equivalence in electricity consumption of X homes. To find out the average electricity consumption of a residential home, just divide the total amount of residential electricity consumed (in TWh) by the number of residential homes =':
          "Équivalence en consommation de x foyers. Pour connaître la consommation électrique moyenne d'un foyer résidentiel, il suffit de diviser la quantité totale d'électricité résidentielle consommée (en TWh) par le nombre de foyers résidentiels =",
        'kWh annual electricity consumption per household.':
          'kWh consommation électrique annuelle par foyer.',
        'Avoided CO2 : Traditional GOs':
          'Emissions de CO2 évitées : GOs traditionnels',
        'Scope 3 : Transport CO2 emissions':
          'Scope 3 : Emissions de CO2 liées au transport',
        "Avoided CO2 : Certified On Attributes's blockchain":
          'Emissions de CO2 évitées (certifiées sur la blockchain de Attributes)',
        'Avoided CO2 : Certified by Attributes':
          'Emissions de CO2 évitées (certifiées par Attributes)',
        'Tracked avoided CO2 emissions': 'CO2 évité',
        'Avoided CO2 in kg': 'CO2 évité en kg',
        'Avoided CO2 in lb': 'CO2 évité en lb',
        'Power in kWh': 'Energie en kWh',
        Date: 'Date',
        'Delivery Id': 'Id de livraison',
        Product: 'Produit',
        'Avoided CO2 (kg)': 'CO2 évité (kg)',
        'CO2 Emissions (kg)': 'Émissions de CO2 (kg)',
        'Site Id': 'Id du site',
        Reference: 'Référence',
        Customer: 'Client',
        'Customer Id': 'Id du client',
        'Download PDF': 'Télécharger le PDF',
        'Generating your PDF...': 'PDF en cours de génération...',
        'Loading the data, please wait':
          'Chargement des données, veuillez patienter',
        'Total Green Energy': 'Total énergie verte',
        on: 'sur',
        'out of': 'sur',
        consumed: 'consommés',
        'From wind turbines': "D'éoliennes",
        'From hydroelectric power': 'De barrages',
        'From solar panels': 'De panneaux solaires',
        'From geothermal': 'De la géothermie',
        'From solid biomass': 'De biomasse solide',
        'Consuming assets': 'Sites de Consommation',
        'Energy produced by ': 'Energie produite par ',
        'Asset production': 'Production du site',
        'Energy from ': '',
        Wind: 'Parc éolien ',
        Solar: 'Solar',
        RunRiverHydro: "Centrale hydroélectrique au fil de l'eau ",
        Geothermal: 'Géothermie',
        SolidBiomass: 'Biomasse solide',
        BiomassGas: 'Gaz de biomasse',
        'matched energy': 'énergie matchée',
        'residual energy': 'énergie résiduelle',
        'Asset matched production': 'Production matchée du site',
        ' (in ': ' (en ',
        Capacity: 'Capacité',
        'Owner  blockchain address': 'Adresse Blockchain ',
        Weather: 'Météo',
        Forecast: 'Prévisions',
        'Check your certificate': 'Vérifiez votre certificat',
        'Check your report': 'Vérifiez votre rapport',
        "Upload your certificate and check it's authenticity.":
          'Téléchargez votre certificat et vérifiez son authenticité.',
        'Upload your report and check its authenticity.':
          'Téléchargez votre rapport et vérifiez son authenticité.',
        'Drag and drop your certificate here':
          'Faites glisser et déposez votre certificat ici',
        'Drag and drop your report here':
          'Faites glisser et déposez votre rapport ici',
        'Checking your certificate...': 'Vérification de votre certificat...',
        'Checking your report...': 'Vérification de votre rapport...',
        'Sorry, we can’t find this certificate':
          'Désolé, nous ne pouvons pas trouver ce certificat',
        'Sorry, we can’t find this report':
          'Désolé, nous ne pouvons pas trouver ce rapport',
        'This certificate is authentic': 'Ce certificat est authentique',
        'This report is authentic': 'Ce rapport est authentique',
        Power: 'Puissance',
        'Production date ': 'Date de production ',
        'No certificate uploaded': 'Aucun certificat téléchargé',
        'No report uploaded': 'Aucun rapport téléchargé',
        'No figures': 'Pas de chiffres',
        Stacked: 'Empilé',
        'Not stacked': 'Non empilé',
        Download: 'Télécharger',
        'Consumption & related Production': 'Consommation & Production',
        'The consumption of the asset compared to the renewable energy producing assets':
          'Consommation totale et production des sites d’énergie renouvelables connectés',
        'Key figures': 'Chiffres clés',
        'Last 30 days': '30 derniers jours',
        'last 30 days': '30 derniers jours',
        Monthly: 'Mensuel',
        'Last month': 'Le mois dernier',
        'last day': 'dernier jour',
        'Last 12 months': 'Les 12 derniers mois',
        'last 12 months': 'les 12 derniers mois',
        Yearly: 'Annuel',
        'Energy sources ratio': 'Origine de votre électricité',
        'Matching ratio': 'Le ratio de matching',
        ratio: 'ratio',
        'The matching rate for each date and hour':
          'Le taux de matching pour chaque date et heure',
        'Average matching ratio': 'Le ratio de matching moyen',
        'The average matching rate per hour':
          'Le taux de matching moyen par heure',
        "The sources of your asset's energy consumption":
          'Origine de l’électricité consommée par le site',
        'Yesterday’s energy sources': 'Origine de votre électricité pour hier',
        'Energy Sources for the': 'Origine de votre électricité pour le',
        "The sources of your asset's energy consumption (yesterday)":
          'Origine de l’électricité consommée par le site pour la journée d’hier',
        "The sources of your asset's energy consumption for this date":
          'Origine de l’électricité consommée par le site pour cette date',
        'Average matching distance':
          'Distance moyenne pondérée des sites de productions',
        'Average distance': 'Distance moyenne',
        ' ton': ' tonnes',
        tons: ' tonnes',
        ton: ' tonne',
        RowsPerPage: 'Lignes par page:',
        ' of ': ' de ',
        'Filter list': 'Liste de filtres',
        'Export data': 'Exporter les données',
        'Delevery Id': 'Id de livraison',
        'Site id or name': 'Id ou nom du site',
        'Customer id or name': 'Id ou nom du client',
        'Filter by product': 'Filtrer par produit',
        Start: 'Début',
        End: 'Fin',
        'Matching date': 'Date du matching',
        'Start date': 'Date de début',
        'End date': 'Date de fin',
        'check transaction': 'vérifier la transaction',
        'Download certificate': 'Télécharger le certificat',
        Sort: 'Trier',
        'Wind (Fontanelles)': '\u00c9olienne (Fontanelles)',
        'Energy Mix': 'Mix Energétique',
        'Lida consumption': 'Consommation de Lida',
        'Marèges produced energy': '\u00c9nergie produite par Marèges',
        'Fontanelles produced energy': '\u00c9nergie produite par Fontanelles',
        'Eget produced energy': '\u00c9nergie produite par Eget',
        'Soulom produced energy': '\u00c9nergie produite par Soulom',
        YYYY: 'DD',
        MM: 'MM',
        'DD ': 'YYYY ',
        HH: 'HH',
        mm: 'mm',
        'Green Energy Certificate': "Certificat d'\u00c9nergie Verte",
        'For the amount of': 'Pour une quantité de',
        ' Kilo Watt-Hour (': ' Kilo Watt-heure (',
        ' kg of CO2 saved )': ' kg de CO2 évité )',
        'of CO2 avoided': 'de CO2 évité',
        'Produced by the renewable ': 'Produit par le site renouvelable de ',
        'Produced by the renewable asset': 'Produit par le site renouvelable',
        ' resource': '',
        ' Blockchain address ': ' Compte Blockchain ',
        'On the date': 'En date du',
        'On the date (in UTC)': 'En date (UTC) du',
        'For month of': 'Pour le mois de',
        'Used for the exclusive and sole account of':
          'Utilisé pour le compte exclusif de',
        'Transferred on ': 'Transféré en date du ',
        'Transferred ': 'Transféré ',
        ' to account': ' au compte',
        'This information is publicly and unalterably available in the Blockchain : ':
          'Cette information est stockée publiquement et de manière inaltérable dans la blockchain : ',
        'and can be visible here ': 'et peut-être visible ici ',
        unauthorized:
          "Vous n'êtes pas autorisé à accéder à cette page, contactez un administrateur",
        Firstname: 'Firstname',
        Lastname: 'Lastname',
      },
    },
    de: {
      translations: {
        'To get started, edit <1>src/App.js</1> and save to reload.':
          'Starte in dem du, <1>src/App.js</1> editierst und speicherst.',
        'Welcome to Attributes': 'Willkommen bei Attributes',
        Username: 'Nutzername',
        Password: 'Passwort',
        'Sign In': 'Anmelden',
        Users: 'Users',
        Organizations: 'Organizations',
        Organization: 'Organization',
        'There is no organization yet': 'There is no organization yet',
        'Check certificate': 'Zertifikatsverifizierung',
        'Check certificate’s authenticity':
          'Überprüfen Sie die Authentizität des Zertifikats',
        'Producing assets': 'Produktionsgüter',
        'Made with': 'Gemacht mit',
        by: 'durch',
        'Certified on the Energy Web Foundation Blockchain':
          'und auf der Energy Web Foundation Blockchain zertifiziert',
        Site: 'Der Standort',
        'Consumption assets': 'Verbrauchsgüter',
        'Production assets': 'Produktionsanlagen',
        Export: 'Export',
        Unit: 'Maßeinheit',
        'Select report unit': 'Wählen Sie die Maßeinheit',
        'All (fem)': 'Alle',
        All: 'Alle',
        'Select organization': 'Wählen Sie eine Organisation aus',
        Between: 'Zwischen',
        For: 'Für',
        'Please wait': 'Warten Sie mal',
        'Production report': 'Energieerzeugungsbericht',
        'Export monthly energy production data':
          'Exportieren Sie monatliche Energieerzeugungsdaten',
        Certificates: 'Zertifikate',
        'Customer deliveries': 'Kundenlieferungen',
        Dashboard: 'Dashboard',
        Method: 'Method',
        Logout: 'Ausloggen',
        Asset: 'Vermögenswert',
        Owner: 'Inhaber',
        'Avoided CO2': 'Avoided CO2',
        'Avoided CO2 : Traditional GOs': 'Avoided CO2 : Traditional GOs',
        'Scope 3 transport CO2 emissions': 'Scope 3 : Transport CO2 emissions',
        'Avoided CO2 : Tracked through blockchain':
          'Avoided CO2 : Tracked through blockchain',
        'Tracked avoided CO2 emissions': 'Vermiedenes CO2',
        'Avoided CO2 in kg': 'Vermiedenes CO2 in kg',
        'Avoided CO2 in lb': 'Vermiedenes CO2 in lb',
        'Power in kWh': 'Leistung in kWh',
        Date: 'Datum',
        'Delivery Id': 'Liefer-ID',
        Product: 'Produkt',
        'Avoided CO2 (kg)': 'Vermiedenes CO2 (kg)',
        'CO2 Emissions (kg)': 'CO2-Emissionen (kg)',
        'Site Id': 'Webseitenadresse',
        Customer: 'Kunde',
        'Customer Id': 'Kunden-ID',
        'Download PDF': 'PDF herunterladen',
        'Consuming assets': 'Konsumgüter',
        'Energy produced by ': 'Energy produced by ',
        'Asset production': 'Anlagenproduktion',
        'Energy from ': 'Energie aus ',
        Wind: 'Wind',
        Solar: 'Solar',
        RunRiverHydro: 'RunRiverHydro',
        Geothermal: 'Geothermal',
        SolidBiomass: 'SolidBiomass',
        BiomassGas: 'BiomassGas',
        'matched energy': 'matched energy',
        'residual energy': 'residual energy',
        'Asset matched production': 'Asset matched production',
        ' (in ': ' (im ',
        Capacity: 'Kapazität',
        'Owner  blockchain address': 'Besitzer-Blockchain-Adresse',
        Weather: 'Wetter',
        Forecast: 'Prognose',
        'Check your certificate': 'Überprüfen Sie Ihr Zertifikat',
        "Upload your certificate and check it's authenticity.":
          'Laden Sie Ihr Zertifikat hoch und überprüfen Sie es auf Echtheit.',
        'Drag and drop your certificate here':
          'Ziehen Sie Ihr Zertifikat hierher und legen Sie es dort ab',
        'Checking your certificate...': 'Überprüfen Sie Ihr Zertifikat...',
        'Sorry, we can’t find this certificate':
          'Entschuldigung, wir können dieses Zertifikat nicht finden',
        'This certificate is authentic': 'Dieses Zertifikat ist authentisch',
        Power: 'Leistung',
        'Production date ': 'Produktionsdatum ',
        'No certificate uploaded': 'Kein Zertifikat hochgeladen',
        'No figures': 'Keine Zahlen',
        Stacked: 'Gestapelt',
        Download: 'Herunterladen',
        'Consumption & related Production': 'Verbrauch & verwandte Produktion',
        'The consumption of the asset compared to the renewable energy producing assets':
          'Der Verbrauch der Vermögenswerte im Vergleich zu den erneuerbaren Energie produzierenden Vermögenswerten',
        'Key figures': 'Key figures',
        'Last 30 days': 'Last 30 days',
        Yearly: 'Yearly',
        'Energy sources ratio': 'Energiequellen Verhältnis',
        "The sources of your asset's energy consumption":
          'Die Quellen des Energieverbrauchs Ihres Assets (Letzte 30 Tage)',
        'Yesterday’s energy sources': 'Energiequellen von gestern',
        "The sources of your asset's energy consumption (yesterday)":
          'Die Quellen des Energieverbrauchs Ihres Assets (gestern)',
        'Average matching distance':
          'Durchschnittliche übereinstimmungsdistanz',
        ' ton': ' tonne',
        tons: ' tonne',
        ton: ' tonne',
        RowsPerPage: 'Zeilen pro Seite:',
        ' of ': ' von ',
        'Filter list': 'Filterliste',
        'Export data': 'Daten exportieren',
        'Delevery Id': 'Liefer-ID',
        'Site id or name': 'Site-ID oder Name',
        'Customer id or name': 'Kunden-ID oder Name',
        'Filter by product': 'Nach Produkt filtern',
        Start: 'Anfang',
        End: 'Ende',
        'Matching date': 'Matching date',
        'Start date': 'Anfang',
        'End date': 'Ende',
        'check transaction': 'Transaktion prüfen',
        'Download certificate': 'Zertifikat herunterladen',
        Sort: 'Sortieren',
        'Wind (Fontanelles)': 'Wind (Fontanelles)',
        'Energy Mix': 'Energiemix',
        'Lida consumption': 'Lida-Verbrauch',
        'Marèges produced energy': 'Marèges produzierte Energie',
        'Fontanelles produced energy': 'Fontanelles produzierte Energie',
        'Eget produced energy': 'Eget produzierte Energie',
        'Soulom produced energy': 'Soulom produzierte Energie',
        YYYY: 'YYYY',
        MM: 'MM',
        'DD ': 'DD ',
        HH: 'HH',
        mm: 'mm',
        'Green Energy Certificate': 'Green Energy Certificate',
        'For the amount of': 'For the amount of',
        ' Kilo Watt-Hour (': ' Kilo Watt-Hour (',
        ' kg of CO2 saved )': ' kg of CO2 saved )',
        'of CO2 avoided': 'of CO2 avoided',
        'Produced by the renewable ': 'Produced by the renewable ',
        ' resource': ' resource',
        ' Blockchain address ': ' Blockchain address ',
        'On the date': 'On the date',
        'Used for the exclusive and sole account of':
          'Used for the exclusive and sole account of',
        'Transferred on ': 'Transferred on ',
        ' to account': ' to account',
        'This information is publicly and unalterably available in the Blockchain : ':
          'This information is publicly and unalterably available in the Blockchain : ',
        'and can be visible here ': 'and can be visible here ',
      },
    },
  },
  fallbackLng: 'en',
  debug: false,

  // have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
  },

  react: {
    wait: true,
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js